import React from "react";
import { List, ListItem, Skeleton, Divider } from "@mui/material";

const ChatsListSkeleton = ({ length = 5 }) => (
  <List className="skeleton">
    {Array.from({ length }).map((_, index) => (
      <ListItem key={`chat-skeleton-${index}`} style={{ padding: 0, display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "16px",
            padding: "16px",
            width: "calc(100% - 32px)",
          }}
        >
          <Skeleton variant="circular" width={48} height={48} style={{ backgroundColor: "#F3F4F5" }} />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              width: "calc(100% - 48px - 16px)",
            }}
          >
            <Skeleton variant="rounded" width="50%" height={10} style={{ backgroundColor: "#F3F4F5" }} />
            <Skeleton variant="rounded" width="80%" height={10} style={{ backgroundColor: "#F3F4F5" }} />
            <Skeleton variant="rounded" width="20%" height={10} style={{ backgroundColor: "#F3F4F5" }} />
          </div>
        </div>
        <Divider key={`chat-skeleton-divider-${index}`} flexItem />
      </ListItem>
    ))}
  </List>
);

export default ChatsListSkeleton;
